import React from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import { Page, Header } from 'components';
import ReportAvailabilityForm from './components/ReportAvailabilityForm';
import ReportSmallCellsImpactForm from './components/ReportSmallCellsImpactForm';
import ReportPPMForm from './components/ReportPPMForm';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	sitelist: {
		marginTop: theme.spacing(6),
	},
}));

const SmallCells = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="Overview">
			<Header
				module="Small Cells"
				view="Reports"
			/>
			<ReportPPMForm />
			<ReportAvailabilityForm />
			<ReportSmallCellsImpactForm />
		</Page>
	);
};

export default SmallCells;
